import { useEffect, useState } from 'react';
import { getVisitsPage } from '../../utils/api/visits';
import { useToasts } from '../../hooks';
import { handleResponse } from '../../utils/api/errorHandler';
import { formatNumericDate } from '../../utils/dates';

const useFetchVisits = (organizationId, params, currentPage, itemsPerPage, setTotalVisits, setTotalUnfilteredVisits = () => {}, setIsLoading) => {
  const [visits, setVisits] = useState([]);
  const { showToast } = useToasts();
  useEffect(() => {
    const fetchVisits = async () => {
      setIsLoading(true);
      try {
        const queryParams = {
          ...params,
          page: currentPage,
          per_page: itemsPerPage,
        };

        // Remove undefined fields
        Object.keys(queryParams).forEach(key => {
          if (queryParams[key] === undefined) {
            delete queryParams[key];
          }
        });

        const response = await getVisitsPage(organizationId, queryParams);
        const data = await handleResponse(response);

        if (!data.visits) {
          throw new Error(data.error || 'No visits found');
        }

        const newData = data.visits.map(visit => (
          {
            ...visit,
            updated_at: formatNumericDate(visit.updated_at),
            completed: visit.completed,
          }
        ));
        setVisits(newData);
        setTotalVisits(data.is_filtered ? data.result_count : data.total_count);
        setTotalUnfilteredVisits(data.total_count);
      } catch (error) {
        showToast({
          message: `Failed to fetch visits: ${error.message}`,
          type: 'error',
        });
      } finally {
        setIsLoading(false);
      }
    };
    fetchVisits();
  }, [organizationId, currentPage, params, itemsPerPage, setTotalVisits, setTotalUnfilteredVisits, showToast, setIsLoading]);
  return visits;
};

export default useFetchVisits;
